export default {
      id: "department-usage",
      viewBox: "0 0 480 480",
      url: "/assets/" + "icons.svg#department",
      toString: function () {
        return this.url;
      }
    }